import { render } from "./AttachmentChart.vue?vue&type=template&id=28b49952"
import script from "./AttachmentChart.vue?vue&type=script&lang=js"
export * from "./AttachmentChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__